import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Translate from "../components/Translate";
import { FaTelegram, FaFacebook, FaWeibo, FaGlobe } from "react-icons/fa";

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: '#990000',
        color: '#EEEEEE',
        padding: '10px 30px'
    },
    disclosure: {
        fontSize: '10px'
    },
    links: {
        color: '#EEEEEE',
        paddingLeft: '20px',
        paddingRight: '20px',
        "&:hover": {
            color: "#CCCCCC"
        },
    }

}));

const Footer = () => {
    const classes = useStyles();
    return (
        <div role="presentation" className={classes.footer}>
            <center>
                <p>{Translate("©2021 美國好康折扣快報-讓您成為購物達人!")}</p>
                <p>
                    <a className={classes.links} href="https://t.me/hoconinfo">
                        <FaTelegram />Telegram
                    </a>
                    <a className={classes.links} href="https://www.facebook.com/groups/hocon">
                        <FaFacebook />Facebook
                    </a>
                    <a className={classes.links} href="https://www.weibo.com/hoconinfo">
                        <FaWeibo />{Translate("新浪微博")}
                    </a>
                    <a className={classes.links} href="https://mewe.com/join/hocon">
                        <FaGlobe />MeWe{Translate("美國好康群")}
                    </a>
                </p>
                <p className={classes.disclosure}>"Disclosure: Many links, product deals, banners, and offers on this site are from merchants that Hoconinfo.com has affiliate relationships with. This means that we may earn commission (at no additional charge to you) when you purchase products through our links or click on certain ads. We are a participant in the Amazon ServicesLLC Associates Program, an affiliate advertising program designed to provide a means for us to earn fees by linking to Amazon.com and affiliated sites."</p>
            </center>
        </div>
    );
}

export default Footer;